// Footer component - matches Magnus Core styling
import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="bg-gradient-to-r from-blue-600 to-indigo-600 py-3 px-6 text-center">
            <p className="text-white font-bold text-sm">
                &copy; {new Date().getFullYear()} AutoGain Insight Systems LLC. All rights reserved.
            </p>
        </footer>
    );
};

export default Footer;


